<template>
    <div>
        <CFTitle title="1. Solicitant"></CFTitle>

        <!--    PARTEA UNU    -->
        <CFSubtitle subtitle="Date de identificare"></CFSubtitle>
        <div>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Denumire"
                class="w-100 custom-responsive"
            >
                <b-form-input
                    id="name"
                    v-model="form.name"
                    type="text"
                    name="message"
                    readonly
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Tipul organizației - se selectează din nomenclator"
                class="w-100 custom-responsive"
            >
                <div class="inline-inputs select-input imm">
                    <b-form-select
                        v-model="form.imm_type"
                        :options="immTypes"
                        disabled
                    >
                    </b-form-select>
                </div>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Cod fiscal"
                class="w-100 custom-responsive"
            >
                <div class="inline-inputs">
                    <b-form-input
                        v-model="form.business_id"
                        type="text"
                        readonly
                    ></b-form-input>
                </div>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Nr. înregistrare"
                class="w-100 custom-responsive"
            >
                <div class="inline-inputs">
                    <b-form-input
                        v-model="form.reg_no"
                        type="text"
                        readonly
                    ></b-form-input>
                </div>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Registru - se selectează din nomenclator"
                class="w-100 custom-responsive"
            >
                <div class="inline-inputs select-input imm">
                    <b-form-select
                        v-model="form.registry"
                        :options="registryTypes"
                        disabled
                    >
                    </b-form-select>
                </div>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Cod CAEN - se selectează din nomenclator"
                class="w-100 custom-responsive"
            >
                <div class="inline-inputs">
                    <b-form-input
                        v-model="form.caen"
                        type="text"
                        readonly
                    ></b-form-input>
                </div>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Data înființării"
                class="w-100 custom-responsive"
            >
                <div class="inline-inputs ">
                    <b-form-input
                        v-model="form.register_date"
                        type="text"
                        readonly
                    ></b-form-input>
                </div>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="TVA deductibil"
                class="w-100 custom-responsive"
            >
                <div class="inline-inputs ">
                    <b-form-radio-group v-model="form.tva" :options="tvaTypes" name="tva" disabled></b-form-radio-group>
                </div>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Public"
                class="w-100 custom-responsive"
            >
                <div class="inline-inputs ">
                    <b-form-radio-group v-model="form.tvaPublic" :options="tvaTypes" name="tvaPublic" disabled></b-form-radio-group>
                </div>
            </b-form-group>
        </div>
        <p class="info-text">Info:  Pentru a modifica aceste informații vă rugăm să vizitați secțiunea: <router-link to="/aplicatii/m3-sketch/compania-mea">Compania mea</router-link></p>

        <!--    PARTEA DOI    -->
        <CFSubtitle subtitle="REPREZENTANT LEGAL"></CFSubtitle>
        <M3Warn v-if="form.delegate.type === 'second'" type="yellow" text="Datele despre reprezentatul legal pot fi adăugate din pagina"><template v-slot:link><router-link to="/aplicatii/m3-sketch/compania-mea" style="margin-left: 5px; color: #5a5e6a; font-weight: 600">Compania mea</router-link></template></M3Warn>
        <M3Warn v-else type="yellow"><template v-slot:link>Persoana împuternicită are funcția de <strong>&nbsp;{{ getDelegateTypeName() ? getDelegateTypeName().toLowerCase() : '' }}</strong>. Te rugăm să completezi aici cu datele <strong>&nbsp;administratorului</strong>.</template></M3Warn>
        <div>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Nume"
                class="w-100 custom-responsive"
            >
                <b-form-input
                    id="name"
                    v-model="form.delegate.first_name"
                    type="text"
                    :readonly="form.delegate.type === 'second' || completedSediu"
                    name="message"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Prenume"
                class="w-100 custom-responsive"
            >
                <b-form-input
                    id="name"
                    v-model="form.delegate.last_name"
                    type="text"
                    :readonly="form.delegate.type === 'second' || completedSediu"
                    name="message"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Data nașterii"
                class="w-100 custom-responsive"
            >
                <b-form-input
                    id="name"
                    v-model="form.delegate.birth_date"
                    type="text"
                    :readonly="form.delegate.type === 'second' || completedSediu"
                    name="message"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="CNP"
                class="w-100 custom-responsive"
            >
                <b-form-input
                    id="name"
                    v-model="form.delegate.cnp"
                    type="text"
                    :readonly="form.delegate.type === 'second' || completedSediu"
                    name="message"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Telefon"
                class="w-100 custom-responsive"
            >
                <b-form-input
                    id="name"
                    v-model="form.delegate.phone"
                    type="text"
                    :readonly="form.delegate.type === 'second' || completedSediu"
                    name="message"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Fax"
                class="w-100 custom-responsive"
            >
                <b-form-input
                    id="name"
                    v-model="form.delegate.fax"
                    type="text"
                    :readonly="form.delegate.type === 'second' || completedSediu"
                    name="message"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-sm="3"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="9"
                label="Email"
                class="w-100 custom-responsive"
            >
                <b-form-input
                    id="name"
                    v-model="form.delegate.email"
                    type="text"
                    :readonly="form.delegate.type === 'second' || completedSediu"
                    name="message"
                ></b-form-input>
            </b-form-group>
        </div>
        <p v-if="form.delegate.type === 'second'" class="info-text">Info:  Pentru a modifica aceste informații vă rugăm să vizitați secțiunea: <router-link to="/aplicatii/m3-sketch/compania-mea">Compania mea</router-link></p>

        <!--    PARTEA TREI    -->
        <CFSubtitle subtitle="SEDIUL SOCIAL"></CFSubtitle>
        <div>
            <div class="flex flex-end mb-1 modify-res">
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="3"
                    content-cols-lg="9"
                    label="Strada"
                    class="has-icon first-input custom-responsive w-48"
                >
                    <b-form-input
                        v-model="form.sediu.street"
                        :readonly="completedSediu"
                        type="text"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="4"
                    content-cols-lg="8"
                    label="Numărul"
                    class="has-icon second-input custom-responsive v-50"
                >
                    <b-form-input
                        v-model="form.sediu.number"
                        :readonly="completedSediu"
                        type="text"
                        name="business_id"
                    ></b-form-input>
                </b-form-group>
            </div>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-lg="3"
                content-cols-lg="9"
                label="Informații extra"
                class="has-icon custom-responsive"
            >
                <b-form-input
                    v-model="form.sediu.infos"
                    :readonly="completedSediu"
                    type="text"
                ></b-form-input>
            </b-form-group>
            <div class="flex flex-end mb-1 modify-res">
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="3"
                    content-cols-lg="9"
                    label="Localitate"
                    class="has-icon first-input custom-responsive w-48"
                >
                    <b-form-input
                        v-model="form.sediu.city"
                        :readonly="completedSediu"
                        type="text"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="4"
                    content-cols-lg="8"
                    label="Cod Poștal"
                    class="has-icon second-input custom-responsive v-50"
                >
                    <b-form-input
                        v-model="form.sediu.postal_code"
                        :readonly="completedSediu"
                        type="text"
                        name="business_id"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="flex flex-end mb-1 modify-res">
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="3"
                    content-cols-lg="9"
                    label="Județ"
                    class="has-icon first-input custom-responsive w-48"
                >
                    <b-form-input
                        v-model="form.sediu.state"
                        :readonly="completedSediu"
                        type="text"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="4"
                    content-cols-lg="8"
                    label="Țară"
                    class="has-icon second-input custom-responsive v-50"
                >
                    <b-form-input
                        v-model="form.sediu.country"
                        :readonly="completedSediu"
                        type="text"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="flex flex-end mb-1 modify-res">
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="3"
                    content-cols-lg="9"
                    label="Telefon"
                    class="has-icon first-input custom-responsive w-48"
                >
                    <b-form-input
                        v-model="form.sediu.phone"
                        :readonly="completedSediu"
                        type="text"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="4"
                    content-cols-lg="8"
                    label="Fax"
                    class="has-icon second-input custom-responsive v-50"
                >
                    <b-form-input
                        v-model="form.sediu.fax"
                        :readonly="completedSediu"
                        type="text"
                    ></b-form-input>
                </b-form-group>
            </div>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-lg="3"
                content-cols-lg="9"
                label="Email"
                class="has-icon custom-responsive"
            >
                <b-form-input
                    v-model="form.sediu.email"
                    :readonly="completedSediu"
                    type="text"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-horizontal"
                label-cols-lg="3"
                content-cols-lg="9"
                label="Pagină web"
                class="has-icon custom-responsive"
            >
                <b-form-input
                    v-model="form.sediu.website"
                    :readonly="completedSediu"
                    type="text"
                ></b-form-input>
            </b-form-group>
        </div>
        <p class="info-text">Info:  Pentru a modifica aceste informații vă rugăm să vizitați secțiunea: <router-link to="/aplicatii/m3-sketch/compania-mea">Compania mea</router-link></p>
        <hr class="mt-0">
        <b-form-checkbox
            v-model="completedSediu"
            switch
            size="lg"
            class="switch-box mb-5"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>


        <!--    PARTEA PATRU    -->
        <CFSubtitle subtitle="DATE FINANCIARE"></CFSubtitle>
        <div>
            <CFDateFinanciare :data="data" :termeneV1="termeneV1" :termeneV3="termeneV3" :m3GrantApplication="m3GrantApplication" @dateFinanciare="completeDateFinanciare($event)"></CFDateFinanciare>
        </div>

        <!--    PARTEA CINCI    -->
        <CFSubtitle subtitle="FINANȚĂRI OBȚINUTE SAU SOLICITATE" style="margin-top: 70px !important;"></CFSubtitle>
        <div>
            <CFFinantariObtinute :m3GrantApplication="m3GrantApplication" @finantariObtinute="completeFinantariObtinute($event)" :cui="form.business_id"></CFFinantariObtinute>
        </div>

    </div>
</template>

<script>
    import CFTitle from './CFTitle'
    import CFSubtitle from './CFSubtitle'
    import CFDateFinanciare from './components/CFDateFinanciare'
    import CFFinantariObtinute from './components/CFFinantariObtinute'
    import { BForm, BFormInput, BFormGroup, BFormSelect, BFormRadioGroup, BFormCheckbox } from "bootstrap-vue";
    import vSelect from 'vue-select'
    import caen from '@/pages/Aplicatii/M3/M3Sketch/caen'
    import {formatUtcDate} from '@/helpers/helpers'
    import M3Warn from "../M3Warn";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'

    export default {
        name: 'CFSolicitant',
        components: {
            CFTitle,
            CFSubtitle,
            BForm,
            BFormInput,
            BFormGroup,
            M3Warn,
            BFormSelect,
            BFormRadioGroup,
            CFDateFinanciare,
            CFFinantariObtinute,
            BFormCheckbox,
            vSelect
        },
        props: {
            data: null,
            termeneV1: null,
            termeneV3: null,
            m3GrantApplication: null
        },
        data() {
            return {
                completedSediu: false,
                form: {
                    name: '',
                    imm_type: '',
                    business_id: '',
                    reg_no: '',
                    registry: 'regcom',
                    caen: '',
                    register_date: '',
                    tva: '',
                    tvaPublic: 'Nu',
                    delegate: {
                        first_name: '',
                        last_name: '',
                        birth_date: '',
                        cnp: '',
                        phone: '',
                        fax: '',
                        email: '',
                        type: ''
                    },
                    sediu: {
                        street: '',
                        number: '',
                        infos: '',
                        postal_code: '',
                        state: '',
                        country: '',
                        phone: '',
                        fax: '',
                        email: '',
                        website: '',
                    },
                    bank_accounts: [],
                    financial_exercises: [],
                    fundingAsked: [],
                    fundingSent: [],
                    fundings: [],
                    fundingNotGranted: false
                },
                immTypes: [
                    { value: 'micro', text: 'ÎNTREPRINDERE MICRO' },
                    { value: 'mică', text: 'ÎNTREPRINDERE MICĂ' },
                    { value: 'mijlocie', text: 'ÎNTREPRINDERE MIJLOCIE' },
                ],
                registryTypes: [
                    { value: 'regcom', text: 'Registrul Comerțului' },
                ],
                caens: caen,
                tvaTypes: [
                    { text: 'Da', value: 'Da' },
                    { text: 'Nu', value: 'Nu' },
                ]

            }
        },
        watch:{
            data: {
                handler: function() {
                    this.getProjectData()
                    if(this.getCompletedSediu()){
                        this.completedSediu = true
                    }
                },
                deep: true
            },
        },
        mounted() {
            this.getProjectData()
            this.saveProgress()
            if(this.getCompletedSediu()){
                this.completedSediu = true
            }
        },
        methods: {
            getDelegateTypeName() {
                if(this.form.delegate.type === 'second') {
                    return 'Administrator'
                } else if(this.form.delegate.type === 'third') {
                    return 'Asociat'
                } else if(this.form.delegate.type === 'four') {
                    return 'Împuternicit'
                } else if(this.form.delegate.type === 'alta') {
                    return this.data.delegate.delegate_type_name
                }
            },
            getProjectData() {
                if(this.data) {
                    this.form.name = this.data.name
                    this.form.imm_type = this.data.imm_type
                    this.form.business_id = this.data.business_id
                    this.form.reg_no = this.data.reg_no
                    if(this.data && this.data.m3_project && !this.data.m3_project.secondary_caen) {
                        this.form.caen = this.data && this.data.m3_project ? (this.data.m3_project.caen + ' - ' + caen[this.data.m3_project.caen]) : ''
                    } else if(this.data && this.data.m3_project && this.data.m3_project.secondary_caen) {
                        this.form.caen = this.data && this.data.m3_project ? (this.data.m3_project.secondary_caen + ' - ' + caen[this.data.m3_project.secondary_caen]) : ''
                    }
                    this.form.register_date = this.data.register_date ? formatUtcDate(this.data.register_date, 'DD.MM.YYYY') : ''
                    this.form.tva = this.data.vat_status === 'PLATITOR' ? 'Da' : this.data.vat_status === 'NEPLATITOR' ? 'Nu' : ''
                    this.form.delegate.type = this.data && this.data.delegate ? this.data.delegate.delegate_type : ''
                    if(this.m3GrantApplication && this.m3GrantApplication.solicitant && this.m3GrantApplication.solicitant.delegate) {
                        this.form.delegate = this.m3GrantApplication.solicitant.delegate
                    } else {
                        this.form.delegate.first_name = this.data.delegate ? this.data.delegate.name.split(' ')[0] : ''
                        this.form.delegate.last_name = this.data.delegate ? this.data.delegate.name.split(' ').slice(1).join(' ') : ''
                        this.form.delegate.birth_date = this.data.delegate ? this.data.delegate.birthdate_place : ''
                        this.form.delegate.cnp = this.data.delegate ? this.data.delegate.cnp : ''
                        this.form.delegate.phone = this.data.delegate ? this.data.delegate.phone : ''
                        this.form.delegate.fax = this.data.delegate ? this.data.delegate.fax : ''
                        this.form.delegate.email = this.data.delegate ? this.data.delegate.email : ''
                    }
                    if(this.m3GrantApplication && this.m3GrantApplication.solicitant && this.m3GrantApplication.solicitant.sediu) {
                        this.form.sediu = this.m3GrantApplication.solicitant.sediu
                    } else {
                        this.form.sediu.street = this.data.street
                        this.form.sediu.infos = this.data.address_info ? this.data.address_info : '-'
                        this.form.sediu.website = this.data.website ? this.data.website : '-'
                        this.form.sediu.number = this.data.street_no
                        this.form.sediu.city = this.data.city
                        this.form.sediu.postal_code = this.data.postal_code
                        this.form.sediu.state = this.data.state
                        this.form.sediu.phone = this.data.phone
                        this.form.sediu.fax = this.data.fax ? this.data.fax : '-'
                        this.form.sediu.email = this.data.email
                        this.form.sediu.country = this.data.country ? this.data.country : 'România'
                    }
                }
            },
            formatUtcDate,
            completeForm() {
                axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {solicitant: this.form})
                    .then( () => {
                        this.$toast.success('Informațiile au fost salvate!')
                        this.$emit('savedData')
                        this.saveProgress()
                    })
            },
            sendForm(){
                if(this.completedSediu){
                    this.completeForm()
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Solicitant')
                }
            },
            getCompletedSediu() {
                if(this.form.sediu.street &&
                    this.form.sediu.infos &&
                    this.form.sediu.website &&
                    this.form.sediu.number &&
                    this.form.sediu.city &&
                    this.form.sediu.postal_code &&
                    this.form.sediu.state &&
                    this.form.sediu.phone &&
                    this.form.sediu.fax &&
                    this.form.sediu.email &&
                    this.form.sediu.country) {
                    return true
                } else {
                    return false
                }
            },
            completeDateFinanciare(event) {
                if(this.m3GrantApplication.solicitant) {
                    this.form = this.m3GrantApplication.solicitant
                }

                this.form.bank_accounts = event.bank_accounts
                this.form.financial_exercises = event.financial_exercises
                this.completeForm()
            },
            completeFinantariObtinute(event) {
                if(this.m3GrantApplication.solicitant) {
                    this.form = this.m3GrantApplication.solicitant
                }

                this.form.fundingAsked = event.fundingAsked
                this.form.fundingSent = event.fundingSent
                this.form.fundings = event.fundings
                this.form.fundingNotGranted = event.fundingNotGranted
                this.completeForm()
            },
            saveProgress() {
                if(this.form.name !== ''
                    && this.form.imm_type !== ''
                    && this.form.business_id !== ''
                    && this.form.reg_no !== ''
                    && this.form.registry !== ''
                    && this.form.caen !== ''
                    && this.form.register_date !== ''
                    && this.form.tva !== ''
                    && this.form.tvaPublic !== ''
                    && this.form.delegate.first_name !== ''
                    && this.form.delegate.last_name !== ''
                    && this.form.delegate.birth_date !== ''
                    && this.form.delegate.cnp !== ''
                    && this.form.delegate.phone !== ''
                    && this.form.delegate.fax !== ''
                    && this.form.delegate.email !== ''
                    && this.form.sediu.street !== ''
                    && this.form.sediu.number !== ''
                    && this.form.sediu.infos !== ''
                    && this.form.sediu.postal_code !== ''
                    && this.form.sediu.state !== ''
                    && this.form.sediu.country !== ''
                    && this.form.sediu.phone !== ''
                    && this.form.sediu.fax !== ''
                    && this.form.sediu.email !== ''
                    && this.form.sediu.website !== ''
                    && this.form.bank_accounts
                    && this.form.bank_accounts.length > 0
                    && this.form.financial_exercises
                    && this.form.financial_exercises.length > 0) {
                    this.$store.dispatch('finantare/addToProgress', 'Solicitant')
                }
            }
        }
    }
</script>

<style scoped>
.flex{
    display: flex;
}
.flex-end{
    justify-content: flex-end;
}
.first-input{
    width: 47%;
}
.second-input{
    width: 40%;
}

.select-input >>> select{
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
    border-radius: 2px;
    max-width: 170px;
    margin-right: 10px;
    margin-bottom: 0;
}
.imm > select {
    min-width: 100%;
    margin-right: 0;
}
.select-input >>> .disabled-select{
    background: #a1fff1;
    opacity: 1;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: center;
}
.inline-inputs{
    display: flex;
}
.inline-inputs div:first-child input{
    width: 100%;
}
.custom-group{
    display: flex;
    flex-wrap: wrap;
}
.custom-select:disabled{
    background: #a1fff1 !important;
    color: #767a95 !important;
    opacity: 1;
}
</style>
